function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#F5F5F0;}\r\n\t.st1{opacity:0.8;fill:#3287BA;stroke:#F5F5F0;stroke-opacity:0.5;enable-background:new    ;}\r\n\t.st2{opacity:0.8;fill:#3287BA;stroke:#EFEFEA;stroke-opacity:0.5;enable-background:new    ;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("polyline", {
  className: "st0",
  points: "-28,-22.9 -22.3,422.9 702.6,422.9 689.7,-22.9 "
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 268,
  cy: 166.5,
  r: 34.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 228.2,
  cy: 414.6,
  r: 30
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 464.6,
  cy: 351.4,
  r: 28.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 506.4,
  cy: 5,
  r: 25.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 533.9,
  cy: 132.9,
  r: 22.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 499.7,
  cy: 46.4,
  r: 20.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 374.4,
  cy: 41.8,
  r: 19.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 571.9,
  cy: 120.2,
  r: 19.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 382,
  cy: 83,
  r: 19.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 422.8,
  cy: 73.8,
  r: 19.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 576.6,
  cy: 139,
  r: 18.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 418.1,
  cy: 137.1,
  r: 18.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 281.3,
  cy: 189.6,
  r: 17.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 485.5,
  cy: 111,
  r: 17.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 363.9,
  cy: 97.4,
  r: 17
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 599.4,
  cy: 208.7,
  r: 16.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 466.5,
  cy: 146.1,
  r: 16.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 263.3,
  cy: -1.8,
  r: 16.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 531.1,
  cy: 78.2,
  r: 15.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 172.2,
  cy: 282,
  r: 15.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 439,
  cy: 63.7,
  r: 15.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 389.6,
  cy: 67.1,
  r: 15.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 580.4,
  cy: 151.4,
  r: 14.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 593.7,
  cy: 211.2,
  r: 14.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 255.7,
  cy: 141,
  r: 14.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 360.1,
  cy: 101.4,
  r: 14.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 582.3,
  cy: 208.8,
  r: 14.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 367.7,
  cy: 146.9,
  r: 14.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 281.3,
  cy: 139.2,
  r: 14.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 538.6,
  cy: 82.2,
  r: 14.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 615.6,
  cy: 334.2,
  r: 13.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 398.1,
  cy: 52.7,
  r: 13.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 206.3,
  cy: 120.2,
  r: 13.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 601.3,
  cy: 154.3,
  r: 13.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 293.7,
  cy: 25.7,
  r: 13.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 421.9,
  cy: 169.5,
  r: 13.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 547.2,
  cy: 134.5,
  r: 13.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 583.3,
  cy: 347.7,
  r: 13.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 330.7,
  cy: -1.2,
  r: 13.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 151.3,
  cy: 201.3,
  r: 13.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 507.3,
  cy: -14.2,
  r: 13.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 608,
  cy: 262.9,
  r: 13.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 211.1,
  cy: 293.4,
  r: 13.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 311.7,
  cy: 107.8,
  r: 13.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 344,
  cy: 107.4,
  r: 13.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 539.6,
  cy: 176.8,
  r: 13.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 397.2,
  cy: 19,
  r: 13.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 588,
  cy: 133.2,
  r: 13.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 582.3,
  cy: 54.6,
  r: 13
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 362,
  cy: 74.8,
  r: 12.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 599.4,
  cy: 121.9,
  r: 12.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 481.7,
  cy: 108.1,
  r: 12.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 508.3,
  cy: 129.7,
  r: 12.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 503.5,
  cy: 74.5,
  r: 12.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 616.5,
  cy: 193.3,
  r: 12.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 309.8,
  cy: 219.1,
  r: 12.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 410.5,
  cy: 0.7,
  r: 12.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 372.5,
  cy: 129.4,
  r: 12.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 367.7,
  cy: 79.4,
  r: 12.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 328.8,
  cy: 149,
  r: 12.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 145.6,
  cy: 244.3,
  r: 12.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 398.1,
  cy: 108.3,
  r: 12.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 612.7,
  cy: 279.8,
  r: 12.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 329.8,
  cy: 166.7,
  r: 12.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 312.7,
  cy: 96.3,
  r: 12.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 405.7,
  cy: 75.6,
  r: 12.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 616.5,
  cy: 90.4,
  r: 12.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 243.4,
  cy: 170.4,
  r: 12
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 576.6,
  cy: 102.6,
  r: 11.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 477.9,
  cy: 88.5,
  r: 11.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 593.7,
  cy: 388.7,
  r: 11.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 274.7,
  cy: 157,
  r: 11.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 236.7,
  cy: 93,
  r: 11.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 219.6,
  cy: 193.7,
  r: 11.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 399.1,
  cy: 102.6,
  r: 11.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 481.7,
  cy: 82.5,
  r: 11.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 317.4,
  cy: 90.9,
  r: 11.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 537.7,
  cy: 68.5,
  r: 11.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 215.8,
  cy: 134.2,
  r: 11.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 251.9,
  cy: 130.2,
  r: 11.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 178.8,
  cy: 223.6,
  r: 11.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 389.6,
  cy: 252.1,
  r: 11
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 202.5,
  cy: 132.4,
  r: 11
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 320.3,
  cy: 201.5,
  r: 10.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 304.1,
  cy: 135.6,
  r: 10.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 356.3,
  cy: 72.4,
  r: 10.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 624.1,
  cy: 252.6,
  r: 10.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 309.8,
  cy: 178.8,
  r: 10.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 271.8,
  cy: 25.1,
  r: 10.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 207.3,
  cy: 247.9,
  r: 10.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 271.8,
  cy: 265,
  r: 10.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 226.3,
  cy: 206.1,
  r: 10.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 577.6,
  cy: 130.5,
  r: 10.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 286.1,
  cy: 285.6,
  r: 10.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 239.6,
  cy: 186.5,
  r: 10.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 387.7,
  cy: 130.4,
  r: 10.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 290.8,
  cy: 51.1,
  r: 10.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 421.9,
  cy: 64,
  r: 10.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 383.9,
  cy: 56.7,
  r: 10.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 311.7,
  cy: 275.5,
  r: 10.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 195.9,
  cy: 289.7,
  r: 10.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 214.9,
  cy: 252.5,
  r: 10.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 157.9,
  cy: 202.8,
  r: 10.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 211.1,
  cy: 149.1,
  r: 10.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 295.6,
  cy: 116.9,
  r: 10.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 261.4,
  cy: 215.9,
  r: 10.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 379.1,
  cy: 24.1,
  r: 10.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 90.5,
  cy: 334.6,
  r: 10.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 627,
  cy: 259.4,
  r: 10.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 295.6,
  cy: 224.8,
  r: 10.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 177.8,
  cy: 297.6,
  r: 10
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 345.9,
  cy: 94.8,
  r: 10
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 279.4,
  cy: 37.3,
  r: 9.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 402.9,
  cy: -41,
  r: 9.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 197.8,
  cy: 180.6,
  r: 9.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 318.4,
  cy: 74.6,
  r: 9.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 236.7,
  cy: 182,
  r: 9.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 307,
  cy: 68.7,
  r: 9.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 279.4,
  cy: 129.2,
  r: 9.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 233.9,
  cy: 259.6,
  r: 9.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 349.7,
  cy: 191.6,
  r: 9.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 256.7,
  cy: 186,
  r: 9.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 501.6,
  cy: 119.2,
  r: 9.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 251,
  cy: 232.7,
  r: 9.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 309.8,
  cy: -41,
  r: 9.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 421.9,
  cy: 87.5,
  r: 9.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 454.1,
  cy: -3.1,
  r: 9.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 251,
  cy: -33.7,
  r: 9.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 127.5,
  cy: 273.3,
  r: 9.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 327.9,
  cy: 146.3,
  r: 9.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 256.7,
  cy: 193.3,
  r: 9.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 259.5,
  cy: 161.8,
  r: 9.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 90.5,
  cy: 259.2,
  r: 9.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 349.7,
  cy: 115.7,
  r: 9.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 217.7,
  cy: 311.3,
  r: 9.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 211.1,
  cy: 166.9,
  r: 9.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 337.4,
  cy: 148.1,
  r: 9.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 251.9,
  cy: 256.2,
  r: 9.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 437.1,
  cy: 212.4,
  r: 9.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 119,
  cy: 91.5,
  r: 9.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 221.5,
  cy: 212.2,
  r: 9.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 205.4,
  cy: 268.8,
  r: 9.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 223.4,
  cy: 150.5,
  r: 9.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 217.7,
  cy: 135.6,
  r: 9.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 324.1,
  cy: 237.8,
  r: 9.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 493.1,
  cy: 183.1,
  r: 9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 265.2,
  cy: 148.6,
  r: 9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 352.6,
  cy: 243.5,
  r: 9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 89.5,
  cy: 229,
  r: 9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 508.3,
  cy: 52,
  r: 9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 286.1,
  cy: 213.1,
  r: 9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 257.6,
  cy: 263.2,
  r: 8.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 319.3,
  cy: 117.4,
  r: 8.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 245.3,
  cy: 274.6,
  r: 8.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 107.6,
  cy: 326.9,
  r: 8.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 234.8,
  cy: 194.9,
  r: 8.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 291.8,
  cy: 141.9,
  r: 8.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 336.4,
  cy: 304.3,
  r: 8.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 389.6,
  cy: 166.5,
  r: 8.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 233.9,
  cy: 288.2,
  r: 8.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 176.9,
  cy: 296.6,
  r: 8.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 346.9,
  cy: 184.2,
  r: 8.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 415.2,
  cy: 208.6,
  r: 8.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 353.5,
  cy: 128.7,
  r: 8.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 204.4,
  cy: 177.4,
  r: 8.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 345.9,
  cy: 208.2,
  r: 8.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 271.8,
  cy: 198.9,
  r: 8.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 333.6,
  cy: 267.1,
  r: 8.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 269,
  cy: 188.1,
  r: 8.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 274.7,
  cy: 225.2,
  r: 8.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 181.6,
  cy: 332.5,
  r: 8.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 233.9,
  cy: 271.2,
  r: 8.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 283.2,
  cy: 132,
  r: 8.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 273.7,
  cy: 227.8,
  r: 8.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 348.8,
  cy: -15.3,
  r: 8.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 209.2,
  cy: 204.3,
  r: 8.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 207.3,
  cy: 214,
  r: 8.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 291.8,
  cy: 370.9,
  r: 8.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 539.6,
  cy: 220.5,
  r: 8.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 153.2,
  cy: 99,
  r: 8.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 258.6,
  cy: 176.7,
  r: 8.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 487.4,
  cy: 119,
  r: 8.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 166.5,
  cy: 310.8,
  r: 8.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 252.9,
  cy: 234.8,
  r: 8.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 290.8,
  cy: 171.9,
  r: 8.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 260.5,
  cy: 244.2,
  r: 8.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 425.7,
  cy: 235.8,
  r: 8.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 280.4,
  cy: 90.6,
  r: 8.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 251.9,
  cy: 231.2,
  r: 8.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 421.9,
  cy: 160.4,
  r: 8.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 269,
  cy: 173.5,
  r: 8.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 210.1,
  cy: 139.7,
  r: 8.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 288.9,
  cy: 179.7,
  r: 8.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 377.2,
  cy: 56,
  r: 8.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 308.9,
  cy: 208.8,
  r: 8.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 250,
  cy: 270.8,
  r: 8.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 277.5,
  cy: 156.5,
  r: 8.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 281.3,
  cy: 222.8,
  r: 8.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 207.3,
  cy: 229.3,
  r: 8.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 273.7,
  cy: 265.5,
  r: 8.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 272.8,
  cy: 211.3,
  r: 8.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 320.3,
  cy: 171.3,
  r: 8.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 248.1,
  cy: 170.1,
  r: 8.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 432.3,
  cy: 168.6,
  r: 8.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 164.6,
  cy: 271.5,
  r: 8.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 281.3,
  cy: 229.2,
  r: 8.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 252.9,
  cy: 212.6,
  r: 8.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 232,
  cy: 239.5,
  r: 8.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 408.6,
  cy: 245.6,
  r: 8.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 351.6,
  cy: 99.1,
  r: 8.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 161.7,
  cy: 283.2,
  r: 8.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 131.3,
  cy: 157.7,
  r: 8.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 304.1,
  cy: 251.4,
  r: 8.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 463.6,
  cy: 125.4,
  r: 8.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 326,
  cy: 203.2,
  r: 8.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 138.9,
  cy: 358.8,
  r: 8.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 527.3,
  cy: 199,
  r: 8.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 136.1,
  cy: 138.5,
  r: 8.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 311.7,
  cy: 227.4,
  r: 8.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 542.4,
  cy: 185.5,
  r: 8.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 101.9,
  cy: 91.3,
  r: 8.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 137,
  cy: 210.8,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 232,
  cy: 200.4,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 228.2,
  cy: 213.1,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 298.4,
  cy: 206.3,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 199.7,
  cy: 220.4,
  r: 7.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 454.1,
  cy: 222.6,
  r: 7.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 249.1,
  cy: 188.3,
  r: 7.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 544.3,
  cy: 222,
  r: 7.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 404.8,
  cy: 165,
  r: 7.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 288.9,
  cy: 208.1,
  r: 7.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 257.6,
  cy: 344.6,
  r: 7.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 176.9,
  cy: 267.9,
  r: 7.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 240.5,
  cy: 95.5,
  r: 7.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 457,
  cy: 161.1,
  r: 7.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 275.6,
  cy: 205.4,
  r: 7.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 448.4,
  cy: 65.7,
  r: 7.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 375.3,
  cy: 121.5,
  r: 7.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 282.3,
  cy: 250.8,
  r: 7.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 526.3,
  cy: 208.9,
  r: 7.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 437.1,
  cy: 201.5,
  r: 7.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 251,
  cy: 293.8,
  r: 7.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 227.2,
  cy: 251.6,
  r: 7.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 169.3,
  cy: 320.2,
  r: 7.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 249.1,
  cy: 164.4,
  r: 7.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 148.4,
  cy: 217.3,
  r: 7.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 159.8,
  cy: 394.6,
  r: 7.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 238.6,
  cy: 312.1,
  r: 7.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 248.1,
  cy: 288.2,
  r: 7.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 174,
  cy: 207.8,
  r: 7.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 270.9,
  cy: 187.5,
  r: 7.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 168.4,
  cy: 181.9,
  r: 7.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 325,
  cy: 158.2,
  r: 7.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 375.3,
  cy: 70.3,
  r: 7.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 215.8,
  cy: 247.8,
  r: 7.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 259.5,
  cy: 165.7,
  r: 7.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 166.5,
  cy: 73.4,
  r: 7.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 273.7,
  cy: 169.6,
  r: 7.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 492.1,
  cy: 183.4,
  r: 7.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 470.3,
  cy: 112.9,
  r: 7.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 215.8,
  cy: 257.8,
  r: 7.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 248.1,
  cy: 180.7,
  r: 7.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 236.7,
  cy: 290.4,
  r: 7.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 469.3,
  cy: 48.4,
  r: 7.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 354.5,
  cy: 233,
  r: 7.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 273.7,
  cy: 3.6,
  r: 7.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 256.7,
  cy: 248.4,
  r: 7.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 503.5,
  cy: 175.5,
  r: 7.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 233.9,
  cy: 280.8,
  r: 7.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 323.1,
  cy: 223.2,
  r: 7.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 260.5,
  cy: 60,
  r: 7.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 239.6,
  cy: 192,
  r: 7.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 349.7,
  cy: 226.5,
  r: 7.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 288.9,
  cy: 288.3,
  r: 7.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 87.6,
  cy: 310.4,
  r: 7.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 206.3,
  cy: 268.6,
  r: 7.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 235.8,
  cy: 118.1,
  r: 7.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 317.4,
  cy: 215.6,
  r: 7.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 213.9,
  cy: 256.3,
  r: 7.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 270.9,
  cy: 296.1,
  r: 7.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 228.2,
  cy: 144.9,
  r: 7.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 144.6,
  cy: 273.4,
  r: 7.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 296.5,
  cy: 255.9,
  r: 7.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 233.9,
  cy: 227.1,
  r: 7.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 307.9,
  cy: 200,
  r: 7.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 587.1,
  cy: 228.6,
  r: 7.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 195.9,
  cy: 208,
  r: 7.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 564.3,
  cy: 162.4,
  r: 7.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 432.3,
  cy: 74.6,
  r: 7.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 315.5,
  cy: 101.4,
  r: 7.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 200.6,
  cy: 266.5,
  r: 7.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 329.8,
  cy: 195.6,
  r: 7.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 233.9,
  cy: 175.8,
  r: 7.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 296.5,
  cy: 251.9,
  r: 7.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 98.1,
  cy: 229.7,
  r: 7.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 79.1,
  cy: 262.9,
  r: 7.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 265.2,
  cy: 168.3,
  r: 7.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 138.9,
  cy: 217.3,
  r: 7.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 321.2,
  cy: 219.4,
  r: 7.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 203.5,
  cy: 231.8,
  r: 7.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 381,
  cy: -70.3,
  r: 7.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 462.7,
  cy: 191.1,
  r: 7.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 384.8,
  cy: 193.5,
  r: 7.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 353.5,
  cy: 209.7,
  r: 7.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 470.3,
  cy: 145.8,
  r: 7.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 334.5,
  cy: 119.8,
  r: 7.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 111.4,
  cy: 221.5,
  r: 7.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 200.6,
  cy: 231.3,
  r: 7.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 240.5,
  cy: 218.1,
  r: 7.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 316.5,
  cy: 198.9,
  r: 7.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 113.3,
  cy: 207.1,
  r: 7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 251.9,
  cy: 276.6,
  r: 7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 540.5,
  cy: 253,
  r: 7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 166.5,
  cy: 121.5,
  r: 7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 185.4,
  cy: 139.9,
  r: 7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 123.7,
  cy: 321.6,
  r: 7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 548.1,
  cy: 210,
  r: 7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 239.6,
  cy: 256.9,
  r: 7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 257.6,
  cy: 285.1,
  r: 7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 188.3,
  cy: 268.3,
  r: 6.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 312.7,
  cy: 205.1,
  r: 6.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 238.6,
  cy: 309.7,
  r: 6.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 375.3,
  cy: 44.1,
  r: 6.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 292.7,
  cy: 127,
  r: 6.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 177.8,
  cy: 276.1,
  r: 6.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 219.6,
  cy: 233.8,
  r: 6.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 590.9,
  cy: 231.2,
  r: 6.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 231,
  cy: 278.5,
  r: 6.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 150.3,
  cy: 217.6,
  r: 6.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 126.6,
  cy: 258.8,
  r: 6.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 56.3,
  cy: 272.9,
  r: 6.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 284.2,
  cy: 221.3,
  r: 6.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 323.1,
  cy: 207.8,
  r: 6.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 154.1,
  cy: 245,
  r: 6.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 233.9,
  cy: 213.4,
  r: 6.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 212,
  cy: 281.8,
  r: 6.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 157.9,
  cy: 267.5,
  r: 6.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 545.3,
  cy: 186.9,
  r: 6.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 132.3,
  cy: 336.6,
  r: 6.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 289.9,
  cy: 137,
  r: 6.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 299.4,
  cy: 244.9,
  r: 6.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 193,
  cy: 101.4,
  r: 6.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 520.6,
  cy: 247.1,
  r: 6.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 183.5,
  cy: 254,
  r: 6.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 199.7,
  cy: 154.9,
  r: 6.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 272.8,
  cy: 269.7,
  r: 6.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 270.9,
  cy: 296.5,
  r: 6.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 345,
  cy: 225.3,
  r: 6.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 159.8,
  cy: 283.5,
  r: 6.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 321.2,
  cy: 216.2,
  r: 6.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 311.7,
  cy: 24.9,
  r: 6.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 198.7,
  cy: 283.7,
  r: 6.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 138.9,
  cy: 200.3,
  r: 6.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 122.8,
  cy: 281,
  r: 6.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 296.5,
  cy: 212.1,
  r: 6.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 334.5,
  cy: 157.2,
  r: 6.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 351.6,
  cy: 281.2,
  r: 6.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 178.8,
  cy: 224,
  r: 6.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 184.5,
  cy: 189.7,
  r: 6.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 197.8,
  cy: 272.8,
  r: 6.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 326.9,
  cy: 175.8,
  r: 6.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 184.5,
  cy: 257.2,
  r: 6.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 375.3,
  cy: 162.7,
  r: 6.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 100.9,
  cy: 302.9,
  r: 6.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 258.6,
  cy: 185.9,
  r: 6.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 415.2,
  cy: 202.6,
  r: 6.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 189.2,
  cy: 137.8,
  r: 6.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 250,
  cy: 195,
  r: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 60.1,
  cy: 274.8,
  r: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 501.6,
  cy: 129.4,
  r: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 545.3,
  cy: 231.5,
  r: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 272.8,
  cy: 170.2,
  r: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 181.6,
  cy: 245.7,
  r: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 165.5,
  cy: 157,
  r: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 290.8,
  cy: 158.3,
  r: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 185.4,
  cy: 247.9,
  r: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 378.2,
  cy: 174.1,
  r: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 181.6,
  cy: 191.5,
  r: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 224.4,
  cy: 204.9,
  r: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 242.4,
  cy: 287.7,
  r: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 215.8,
  cy: 249.7,
  r: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 123.7,
  cy: 192.3,
  r: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 307,
  cy: 225.7,
  r: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 215.8,
  cy: 248.3,
  r: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 229.1,
  cy: 233.5,
  r: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 112.3,
  cy: 287,
  r: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 234.8,
  cy: 250.9,
  r: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 288,
  cy: 159.9,
  r: 6.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 297.5,
  cy: 498.4,
  r: 6.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 185.4,
  cy: 171.1,
  r: 6.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 362,
  cy: 229.7,
  r: 6.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 244.3,
  cy: 220,
  r: 6.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 152.2,
  cy: 229.4,
  r: 6.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 251.9,
  cy: 185.5,
  r: 6.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 298.4,
  cy: 158.1,
  r: 6.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 185.4,
  cy: 276.8,
  r: 6.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 556.7,
  cy: 315.1,
  r: 6.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 568.1,
  cy: 255.9,
  r: 6.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 238.6,
  cy: 280.5,
  r: 6.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 271.8,
  cy: 258.2,
  r: 6.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 235.8,
  cy: 289.5,
  r: 6.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 188.3,
  cy: 209.6,
  r: 6.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 192.1,
  cy: 271.9,
  r: 6.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 289.9,
  cy: 395.7,
  r: 6.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 256.7,
  cy: 208.9,
  r: 6.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 295.6,
  cy: 281.3,
  r: 6.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 161.7,
  cy: 214.3,
  r: 6.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 238.6,
  cy: 170.6,
  r: 6.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 199.7,
  cy: 256.4,
  r: 6.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 180.7,
  cy: 230.6,
  r: 6.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 113.3,
  cy: 248.4,
  r: 6.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 128.5,
  cy: 232.7,
  r: 6.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: -14.9,
  cy: 297.9,
  r: 6.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 280.4,
  cy: 225.1,
  r: 6.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 275.6,
  cy: 409.9,
  r: 6.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 309.8,
  cy: 221.3,
  r: 6.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 341.2,
  cy: 145.7,
  r: 6.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 146.5,
  cy: 303.2,
  r: 6.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 98.1,
  cy: 367.9,
  r: 6.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 234.8,
  cy: 259.7,
  r: 6.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 431.4,
  cy: -34.9,
  r: 6.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 249.1,
  cy: 246.1,
  r: 6.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 242.4,
  cy: 244,
  r: 6.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 133.2,
  cy: 204.8,
  r: 6.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 436.1,
  cy: 221.4,
  r: 6.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 444.7,
  cy: 197.6,
  r: 6.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 382.9,
  cy: 216,
  r: 6.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 311.7,
  cy: 243.9,
  r: 6.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 205.4,
  cy: 232.1,
  r: 6.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 263.3,
  cy: 191.2,
  r: 6.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 254.8,
  cy: 301.3,
  r: 6.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 149.4,
  cy: 50.6,
  r: 6.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: -28.2,
  cy: 356.6,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 409.5,
  cy: 217.1,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 524.4,
  cy: 112.8,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 105.7,
  cy: 266.3,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 184.5,
  cy: 249,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 288,
  cy: 236.1,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 213.9,
  cy: 299.3,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 195.9,
  cy: 278.8,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 251.9,
  cy: 239.2,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: -6.4,
  cy: 264.7,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 114.2,
  cy: 243.7,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 337.4,
  cy: 199.2,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 169.3,
  cy: 110.9,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 155.1,
  cy: 273.6,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 127.5,
  cy: 283.4,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 267.1,
  cy: 246.3,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 180.7,
  cy: 271.8,
  r: 5.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 178.8,
  cy: 205.1,
  r: 5.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 255.7,
  cy: 282.6,
  r: 5.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 443.7,
  cy: 93.3,
  r: 5.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 318.4,
  cy: 214.4,
  r: 5.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 164.6,
  cy: 240.1,
  r: 5.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 132.3,
  cy: 252.1,
  r: 5.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 321.2,
  cy: 252.7,
  r: 5.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 260.5,
  cy: 55.9,
  r: 5.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 26.9,
  cy: 214.8,
  r: 5.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 183.5,
  cy: 273.8,
  r: 5.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 123.7,
  cy: 298.8,
  r: 5.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 116.1,
  cy: 231.7,
  r: 5.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 548.1,
  cy: 174.6,
  r: 5.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 223.4,
  cy: 263.5,
  r: 5.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 513,
  cy: 190.6,
  r: 5.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 147.5,
  cy: 264.8,
  r: 5.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 119,
  cy: 292.3,
  r: 5.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 316.5,
  cy: 296.5,
  r: 5.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 175.9,
  cy: 232.1,
  r: 5.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 137,
  cy: 276.3,
  r: 5.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 161.7,
  cy: 252.4,
  r: 5.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 307.9,
  cy: 182.7,
  r: 5.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 205.4,
  cy: 284.8,
  r: 5.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 161.7,
  cy: 264.4,
  r: 5.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 255.7,
  cy: 220.6,
  r: 5.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 567.1,
  cy: 178.8,
  r: 5.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 127.5,
  cy: 303.3,
  r: 5.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 367.7,
  cy: 122.7,
  r: 5.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 239.6,
  cy: 89.4,
  r: 5.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 160.8,
  cy: 297.9,
  r: 5.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 338.3,
  cy: 225.8,
  r: 5.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 175,
  cy: 289.4,
  r: 5.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 226.3,
  cy: 273.5,
  r: 5.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 237.7,
  cy: 233.7,
  r: 5.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 253.8,
  cy: 274.5,
  r: 5.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 334.5,
  cy: 117.4,
  r: 5.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 135.1,
  cy: 269.5,
  r: 5.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 120.9,
  cy: 137.5,
  r: 5.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 195.9,
  cy: 244.5,
  r: 5.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 128.5,
  cy: 299.4,
  r: 5.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 192.1,
  cy: 276.6,
  r: 5.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 399.1,
  cy: 253.6,
  r: 5.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 246.2,
  cy: 265.1,
  r: 5.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 320.3,
  cy: 236.9,
  r: 5.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 175.9,
  cy: 251.2,
  r: 5.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 179.7,
  cy: 259.5,
  r: 5.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 361.1,
  cy: 249.6,
  r: 5.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 156,
  cy: 224.2,
  r: 5.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 44.9,
  cy: 248.8,
  r: 5.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 146.5,
  cy: 285.4,
  r: 5.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 196.8,
  cy: 254.8,
  r: 5.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 271.8,
  cy: 230,
  r: 5.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 163.6,
  cy: 184.7,
  r: 5.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 218.7,
  cy: 274.8,
  r: 5.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 241.5,
  cy: 239.4,
  r: 5.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 147.5,
  cy: 237.8,
  r: 5.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 177.8,
  cy: 285.1,
  r: 5.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 83.8,
  cy: 260.2,
  r: 5.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 171.2,
  cy: 249.8,
  r: 5.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 211.1,
  cy: 290.6,
  r: 5.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 236.7,
  cy: 241.9,
  r: 5.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 236.7,
  cy: 262.2,
  r: 5.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 135.1,
  cy: 272.9,
  r: 5.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 229.1,
  cy: 182.7,
  r: 5.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 199.7,
  cy: 300.6,
  r: 5.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 200.6,
  cy: 257.7,
  r: 5.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 250,
  cy: 285.9,
  r: 5.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: -50,
  cy: 295.7,
  r: 5.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 150.3,
  cy: 249.9,
  r: 5.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 88.6,
  cy: 282.8,
  r: 5.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 52.5,
  cy: 204,
  r: 5.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 82.9,
  cy: 209.3,
  r: 5.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 120.9,
  cy: 248.4,
  r: 5.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 39.2,
  cy: 335.8,
  r: 5.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 213.9,
  cy: 218,
  r: 5.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 220.6,
  cy: 340.9,
  r: 5.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 199.7,
  cy: 267.5,
  r: 5.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 137,
  cy: 233.4,
  r: 5.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 215.8,
  cy: 220.1,
  r: 5.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 155.1,
  cy: 283,
  r: 5.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 157.9,
  cy: 302.3,
  r: 5.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 293.7,
  cy: 238.4,
  r: 5.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 231,
  cy: 240.8,
  r: 5.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 162.7,
  cy: 238.7,
  r: 5.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 200.6,
  cy: 269.3,
  r: 5.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 237.7,
  cy: 206.1,
  r: 5.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 503.5,
  cy: 123.5,
  r: 5.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 233.9,
  cy: 230.3,
  r: 5.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 207.3,
  cy: 289.6,
  r: 5.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 68.7,
  cy: 295.5,
  r: 5.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 253.8,
  cy: 273.4,
  r: 5.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 266.1,
  cy: 379.7,
  r: 5.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 202.5,
  cy: 217.6,
  r: 5.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 275.6,
  cy: 118.9,
  r: 5.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 10.7,
  cy: 311.3,
  r: 5.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 198.7,
  cy: 252.7,
  r: 5.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 175,
  cy: 282.2,
  r: 5.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 133.2,
  cy: 231.7,
  r: 5.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 256.7,
  cy: 252.7,
  r: 5.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 157,
  cy: 265,
  r: 5.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 237.7,
  cy: 239.8,
  r: 5.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 406.7,
  cy: 269.3,
  r: 5.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 313.6,
  cy: 270.9,
  r: 5.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 191.1,
  cy: 148.8,
  r: 5.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 213.9,
  cy: 286.8,
  r: 5.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 379.1,
  cy: 65.7,
  r: 5.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 175,
  cy: 254.8,
  r: 5.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 282.3,
  cy: 223.6,
  r: 5.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 118,
  cy: 314.7,
  r: 5.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 228.2,
  cy: 297.9,
  r: 5.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 164.6,
  cy: 185.1,
  r: 5.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 351.6,
  cy: 206.3,
  r: 5.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 166.5,
  cy: 207.1,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 116.1,
  cy: 293.3,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 374.4,
  cy: 234.5,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 142.7,
  cy: 218,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 256.7,
  cy: 261.5,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 67.7,
  cy: 295.2,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 517.8,
  cy: 164.3,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 218.7,
  cy: 239.8,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 203.5,
  cy: 270.8,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: -38.6,
  cy: 179.4,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 181.6,
  cy: 243.7,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 230.1,
  cy: 211.5,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 256.7,
  cy: 205.5,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 648.8,
  cy: 220.1,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 112.3,
  cy: 226.1,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 194.9,
  cy: 238.5,
  r: 4.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 269.9,
  cy: 265.3,
  r: 4.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 9.8,
  cy: 343,
  r: 4.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 182.6,
  cy: 256.6,
  r: 4.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 201.6,
  cy: 314.6,
  r: 4.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 145.6,
  cy: 289.8,
  r: 4.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 14.5,
  cy: 177.2,
  r: 4.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 213.9,
  cy: 256.9,
  r: 4.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 333.6,
  cy: 248,
  r: 4.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 175,
  cy: 442,
  r: 4.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 150.3,
  cy: 248.3,
  r: 4.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 114.2,
  cy: 162.3,
  r: 4.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 94.3,
  cy: 317.3,
  r: 4.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 252.9,
  cy: 241.9,
  r: 4.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 153.2,
  cy: 235.4,
  r: 4.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 225.3,
  cy: 242.7,
  r: 4.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 218.7,
  cy: 278,
  r: 4.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 180.7,
  cy: 347.1,
  r: 4.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 234.8,
  cy: 239.6,
  r: 4.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 80.1,
  cy: 250.5,
  r: 4.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 196.8,
  cy: 298,
  r: 4.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 190.2,
  cy: 286.3,
  r: 4.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 231,
  cy: 253.7,
  r: 4.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 249.1,
  cy: 319,
  r: 4.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 308.9,
  cy: 138.8,
  r: 4.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 213,
  cy: 260.3,
  r: 4.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 180.7,
  cy: 286.5,
  r: 4.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 161.7,
  cy: 218.4,
  r: 4.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 111.4,
  cy: 280.7,
  r: 4.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 256.7,
  cy: 235,
  r: 4.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 105.7,
  cy: 239.8,
  r: 4.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 307.9,
  cy: 238.7,
  r: 4.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: -28.2,
  cy: 393.2,
  r: 4.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 256.7,
  cy: 247.7,
  r: 4.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 233.9,
  cy: 271.9,
  r: 4.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 521.6,
  cy: 325.9,
  r: 4.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 181.6,
  cy: 227.4,
  r: 4.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 156,
  cy: 256,
  r: 4.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 161.7,
  cy: 271,
  r: 4.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 619.4,
  cy: 79.3,
  r: 4.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 140.8,
  cy: 125.5,
  r: 4.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 199.7,
  cy: 202.7,
  r: 4.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 116.1,
  cy: 213.1,
  r: 4.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 319.3,
  cy: 289.8,
  r: 4.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 112.3,
  cy: 313.5,
  r: 4.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 220.6,
  cy: 317.3,
  r: 4.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 293.7,
  cy: 254.2,
  r: 4.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 323.1,
  cy: 233.4,
  r: 4.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 139.9,
  cy: 265.9,
  r: 4.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 303.2,
  cy: 283.5,
  r: 4.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 125.6,
  cy: 302.4,
  r: 4.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 42.1,
  cy: 346.3,
  r: 4.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 142.7,
  cy: 368.5,
  r: 4.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 157,
  cy: 255.4,
  r: 4.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 210.1,
  cy: 258.2,
  r: 4.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 174,
  cy: 137.1,
  r: 4.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 126.6,
  cy: 333.8,
  r: 4.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 272.8,
  cy: 257.3,
  r: 4.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 149.4,
  cy: 295,
  r: 4.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 179.7,
  cy: 191.6,
  r: 4.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 231,
  cy: 207.5,
  r: 4.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 162.7,
  cy: 277.9,
  r: 4.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 147.5,
  cy: 248.2,
  r: 4.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 78.2,
  cy: 165.5,
  r: 4.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 241.5,
  cy: 263.8,
  r: 4.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 78.2,
  cy: 276.8,
  r: 4.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 153.2,
  cy: 273,
  r: 4.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 9.8,
  cy: 269,
  r: 4.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 137,
  cy: 270.9,
  r: 4.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 225.3,
  cy: 253.5,
  r: 4.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 163.6,
  cy: 296,
  r: 4.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 193,
  cy: 304.2,
  r: 4.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 147.5,
  cy: 342.9,
  r: 4.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 256.7,
  cy: 280.2,
  r: 4.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 130.4,
  cy: 231.4,
  r: 4.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 137,
  cy: 191.4,
  r: 4.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 200.6,
  cy: 153,
  r: 4.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 144.6,
  cy: 212.9,
  r: 4.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 192.1,
  cy: 166.8,
  r: 4.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 173.1,
  cy: 206,
  r: 4.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 149.4,
  cy: 265.7,
  r: 4.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 77.2,
  cy: 214,
  r: 4.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 157,
  cy: 265.9,
  r: 4.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 178.8,
  cy: 292.3,
  r: 4.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 165.5,
  cy: 309.1,
  r: 4.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 218.7,
  cy: 245.4,
  r: 4.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 227.2,
  cy: 267.3,
  r: 4.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 244.3,
  cy: 283.9,
  r: 4.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 237.7,
  cy: 225.5,
  r: 4.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 237.7,
  cy: 258.8,
  r: 4.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 144.6,
  cy: 299.9,
  r: 4.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 109.5,
  cy: 273.1,
  r: 4.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 123.7,
  cy: 169.3,
  r: 4.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 252.9,
  cy: 176.8,
  r: 4.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 180.7,
  cy: 188.9,
  r: 4.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 144.6,
  cy: 218.4,
  r: 4.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 310.8,
  cy: 273.1,
  r: 4.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 132.3,
  cy: 156.5,
  r: 4.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 269,
  cy: 138.4,
  r: 4.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 66.8,
  cy: 173.3,
  r: 4.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 194,
  cy: 191.3,
  r: 4.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 213,
  cy: 221.3,
  r: 4.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 164.6,
  cy: 224.5,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 118,
  cy: 303.1,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 255.7,
  cy: 83.7,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 320.3,
  cy: 269.3,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 105.7,
  cy: 212.8,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: -47.2,
  cy: 166.1,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 250,
  cy: 266.7,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 136.1,
  cy: 268,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 123.7,
  cy: 186.9,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 78.2,
  cy: 364.6,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 112.3,
  cy: 273.2,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 183.5,
  cy: 293.1,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 198.7,
  cy: 268.1,
  r: 3.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 4.1,
  cy: 163.1,
  r: 3.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 114.2,
  cy: 204.7,
  r: 3.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 9.8,
  cy: 308.7,
  r: 3.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 159.8,
  cy: 351,
  r: 3.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 130.4,
  cy: 258.1,
  r: 3.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: -2.6,
  cy: 377.7,
  r: 3.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: -16.8,
  cy: 242.6,
  r: 3.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 163.6,
  cy: 361.9,
  r: 3.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 380.1,
  cy: 197.6,
  r: 3.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 121.8,
  cy: 203.8,
  r: 3.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 220.6,
  cy: 328.1,
  r: 3.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 176.9,
  cy: 92.7,
  r: 3.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 145.6,
  cy: 271.6,
  r: 3.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 199.7,
  cy: 257.4,
  r: 3.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 157.9,
  cy: 361.4,
  r: 3.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 322.2,
  cy: 220.9,
  r: 3.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 237.7,
  cy: 205.3,
  r: 3.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 142.7,
  cy: 289.6,
  r: 3.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 81,
  cy: 256.8,
  r: 3.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 352.6,
  cy: 107.7,
  r: 3.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 302.2,
  cy: 202.9,
  r: 3.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 238.6,
  cy: 300.3,
  r: 3.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 149.4,
  cy: 297.3,
  r: 3.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 135.1,
  cy: 262.2,
  r: 3.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: -30.1,
  cy: 358.9,
  r: 3.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 119,
  cy: 241.3,
  r: 3.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 227.2,
  cy: 326,
  r: 3.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 126.6,
  cy: 285.3,
  r: 3.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 120.9,
  cy: 242.7,
  r: 3.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 174,
  cy: 306.7,
  r: 3.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 146.5,
  cy: 287.1,
  r: 3.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 81,
  cy: 245.3,
  r: 3.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 44.9,
  cy: 290.5,
  r: 3.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 465.5,
  cy: 176.2,
  r: 3.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 147.5,
  cy: 317.5,
  r: 3.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 352.6,
  cy: 132.3,
  r: 3.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 153.2,
  cy: 288.5,
  r: 3.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 164.6,
  cy: 43.8,
  r: 3.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 33.5,
  cy: 192.3,
  r: 3.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 157.9,
  cy: 314.2,
  r: 3.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 159.8,
  cy: 299.6,
  r: 3.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 177.8,
  cy: 222.9,
  r: 3.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 237.7,
  cy: 329.7,
  r: 3.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 180.7,
  cy: 283.6,
  r: 3.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 420.9,
  cy: 340.2,
  r: 3.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 155.1,
  cy: 299.5,
  r: 3.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: -22.5,
  cy: 224.2,
  r: 3.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 213.9,
  cy: 225.2,
  r: 3.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 88.6,
  cy: 377.6,
  r: 3.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 199.7,
  cy: 294.1,
  r: 3.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 251.9,
  cy: 85.6,
  r: 3.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 401,
  cy: 200.9,
  r: 3.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 86.7,
  cy: 219.2,
  r: 3.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: -23.4,
  cy: 304.8,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 304.1,
  cy: 188,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 244.3,
  cy: 250.1,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 614.6,
  cy: 200.3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 42.1,
  cy: 351,
  r: 2.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 55.4,
  cy: 316.4,
  r: 2.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 161.7,
  cy: 313.1,
  r: 2.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 387.7,
  cy: 254.7,
  r: 2.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 199.7,
  cy: 302,
  r: 2.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 174,
  cy: 73.6,
  r: 2.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 90.5,
  cy: 351,
  r: 2.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 128.5,
  cy: 318.7,
  r: 2.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 108.5,
  cy: 297.8,
  r: 2.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 138.9,
  cy: 363.8,
  r: 2.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 194,
  cy: 251.3,
  r: 2.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 230.1,
  cy: 246.1,
  r: 2.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 237.7,
  cy: 105.8,
  r: 2.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 52.5,
  cy: 148.5,
  r: 2.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 169.3,
  cy: 299.2,
  r: 2.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 238.6,
  cy: 147.9,
  r: 2.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 231,
  cy: 327.3,
  r: 2.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 245.3,
  cy: 369.6,
  r: 2.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 143.7,
  cy: 236.6,
  r: 2.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 81,
  cy: 360.5,
  r: 2.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 157.9,
  cy: 317.5,
  r: 2.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 128.5,
  cy: 261.9,
  r: 2.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 121.8,
  cy: 289.1,
  r: 2.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 218.7,
  cy: 133.7,
  r: 2.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 217.7,
  cy: 115.5,
  r: 2.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 100,
  cy: 293.8,
  r: 2.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 44.9,
  cy: 290.9,
  r: 2.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 43,
  cy: 296.5,
  r: 2.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 185.4,
  cy: 249.5,
  r: 2.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 98.1,
  cy: 328.5,
  r: 2.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 206.3,
  cy: 331.3,
  r: 2.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 109.5,
  cy: 197.5,
  r: 2.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 495,
  cy: -32.1,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 210.1,
  cy: 319.7,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 147.5,
  cy: 185.5,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 108.5,
  cy: 287.9,
  r: 1.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 142.7,
  cy: 278.4,
  r: 1.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 167.4,
  cy: 209,
  r: 1.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 205.4,
  cy: 248.1,
  r: 1.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 103.8,
  cy: 197.2,
  r: 1.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 179.7,
  cy: 197.9,
  r: 1.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 577.6,
  cy: 264.5,
  r: 1.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 323.1,
  cy: 155.6,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 327.9,
  cy: 301.6,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 71.5,
  cy: 325,
  r: 1.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 253.8,
  cy: 296.8,
  r: 1.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 161.7,
  cy: 363.3,
  r: 1.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 577.6,
  cy: 310.7,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 176.9,
  cy: 124.6,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 90.5,
  cy: 288.2,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 128.5,
  cy: 393,
  r: 0.8
}));

var SvgScatter = function SvgScatter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    x: "0px",
    y: "0px",
    viewBox: "0 0 647 400",
    style: {
      enableBackground: "new 0 0 647 400"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScatter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scatter.6de70e7a.svg";
export { ForwardRef as ReactComponent };